import { apiClient } from "./ApiClient";

const DATA_API_URL = `${process.env.VUE_APP_API_BASE_URL}/api/v1/data`;

export default {
  /***
   * Users
   * Day summary
   */
  today({ page, page_size, sort, order, section_id = -1, search_term, dt_at, battery, sync_from, sync_to, platoon_id}) {
    return apiClient.get(
      `${DATA_API_URL}/sections/user_summary_list/${section_id}?page=${page}&page_size=${page_size}
        &sort=${sort}&order=${order}&section_id=${section_id}&search_term=${search_term}&dt_at=${dt_at}
        &battery=${battery}&sync_from=${sync_from}&sync_to=${sync_to}&platoon_id=${platoon_id}`
    );
  },
  /***
   * Sleep
   */
  sleepRangesBySection({ section_id = -1, dt_from, dt_to, platoon_id = -1 }) {
    return apiClient.get(
      `${DATA_API_URL}/sections/sleep_ranges/${section_id}?dt_from=${dt_from}&dt_to=${dt_to}&platoon_id=${platoon_id}`
    );
  },
  sleepDataBySection({
    page,
    page_size,
    sort,
    order,
    section_id = -1,
    dt_from,
    dt_to,
    platoon_id = -1,
  }) {
    return apiClient.get(
      `${DATA_API_URL}/sections/sleep_data/${section_id}?page=${page}&page_size=${page_size}&sort=${sort}&order=${order}&dt_from=${dt_from}&dt_to=${dt_to}&platoon_id=${platoon_id}`
    );
  },
  sleepHoursBySection({ section_id = -1, dt_from, dt_to, platoon_id = -1 }) {
    return apiClient.get(
      `${DATA_API_URL}/sections/sleep_hours/${section_id}?dt_from=${dt_from}&dt_to=${dt_to}&platoon_id=${platoon_id}`
    );
  },
  /***
   * Recovery
   */
  recoveryRangesBySection({ section_id = -1, dt_from, dt_to, platoon_id = -1 }) {
    return apiClient.get(
      `${DATA_API_URL}/sections/recovery_ranges/${section_id}?dt_from=${dt_from}&dt_to=${dt_to}&platoon_id=${platoon_id}`
    );
  },
  recoveryDataBySection({
    page,
    page_size,
    sort,
    order,
    section_id = -1,
    dt_from,
    dt_to,
    platoon_id = -1,
  }) {
    return apiClient.get(
      `${DATA_API_URL}/sections/recovery_data/${section_id}?page=${page}&page_size=${page_size}&sort=${sort}&order=${order}&dt_from=${dt_from}&dt_to=${dt_to}&platoon_id=${platoon_id}`
    );
  },
  avgRecoveryAndHrvBySection({ section_id = -1, dt_from, dt_to, platoon_id = -1 }) {
    return apiClient.get(
      `${DATA_API_URL}/sections/avg_recovery_and_hrv/${section_id}?dt_from=${dt_from}&dt_to=${dt_to}&platoon_id=${platoon_id}`
    );
  },
  /***
   * Strain
   */
  strainRangesBySection({ section_id = -1, dt_from, dt_to, platoon_id = -1 }) {
    return apiClient.get(
      `${DATA_API_URL}/sections/strain_ranges/${section_id}?dt_from=${dt_from}&dt_to=${dt_to}&platoon_id=${platoon_id}`
    );
  },
  strainDataBySection({
    page,
    page_size,
    sort,
    order,
    section_id = -1,
    dt_from,
    dt_to,
    platoon_id = -1,
  }) {
    return apiClient.get(
      `${DATA_API_URL}/sections/strain_data/${section_id}?page=${page}&page_size=${page_size}&sort=${sort}&order=${order}&dt_from=${dt_from}&dt_to=${dt_to}&platoon_id=${platoon_id}`
    );
  },
  strainAvgMaxHrBySection({
    dt_from,
    dt_to,
    section_id = -1,
    workout_type_id = -1,
    platoon_id = -1,
  }) {
    return apiClient.get(
      `${DATA_API_URL}/sections/strain_avg_max_hr/${section_id}?dt_from=${dt_from}&dt_to=${dt_to}&workout_type_id=${workout_type_id}&platoon_id=${platoon_id}`
    );
  },
  strainWorkoutTypesBySection({ dt_from, dt_to, section_id = -1 }) {
    return apiClient.get(
      `${DATA_API_URL}/sections/workouts/workout_types/${section_id}?dt_from=${dt_from}&dt_to=${dt_to}`
    );
  },
  strainWorkoutsBySection({
    page,
    page_size,
    sort,
    order,
    dt_from,
    dt_to,
    section_id = -1,
    workout_type,
  }) {
    return apiClient.get(
      `${DATA_API_URL}/sections/workouts/${section_id}?page=${page}&page_size=${page_size}&sort=${sort}&order=${order}&dt_from=${dt_from}&dt_to=${dt_to}&workout_type=${workout_type}`
    );
  },
  /** Dashboard */
  scoreRanges({ dt_from, dt_to }) {
    return apiClient.get(
      `${DATA_API_URL}/sections/score_ranges?dt_from=${dt_from}&dt_to=${dt_to}`
    );
  },
  performanceByPlatoonAndSection({
    page,
    page_size,
    sort,
    order,
    dt_from,
    dt_to,
    section_id = -1,
    platoon_id = -1,
  }) {
    return apiClient.get(
      `${DATA_API_URL}/sections/performance/${section_id}?page=${page}&page_size=${page_size}&sort=${sort}&order=${order}&dt_from=${dt_from}&dt_to=${dt_to}&platoon_id=${platoon_id}`
    );
  },
  /** User Physiological Data */
  userDataByDate({ udid, dt }) {
    return apiClient.get(`${DATA_API_URL}/users/${udid}?dt=${dt}`);
  },
  userDna({ udid }) {
    return apiClient.get(`${DATA_API_URL}/users/dna/${udid}`);
  },
  userStrainData({ udid, dt_from, dt_to }) {
    return apiClient.get(
      `${DATA_API_URL}/users/strain/${udid}?dt_from=${dt_from}&dt_to=${dt_to}`
    );
  },
  userWorkoutTypes({ udid, dt_from, dt_to }) {
    return apiClient.get(
      `${DATA_API_URL}/users/workout_types/${udid}?dt_from=${dt_from}&dt_to=${dt_to}`
    );
  },
  userWorkouts({
    udid,
    workout_type,
    page,
    page_size,
    sort,
    order,
    dt_from,
    dt_to,
  }) {
    return apiClient.get(
      `${DATA_API_URL}/users/workouts/${udid}/${workout_type}?page=${page}&page_size=${page_size}&sort=${sort}&order=${order}&dt_from=${dt_from}&dt_to=${dt_to}`
    );
  },
  userRecoveryData({ udid, dt_from, dt_to }) {
    return apiClient.get(
      `${DATA_API_URL}/users/recovery/${udid}?dt_from=${dt_from}&dt_to=${dt_to}`
    );
  },
  userSleepData({ udid, sort, order, dt_from, dt_to }) {
    return apiClient.get(
      `${DATA_API_URL}/users/sleep/${udid}?sort=${sort}&order=${order}&dt_from=${dt_from}&dt_to=${dt_to}`
    );
  },
  // Profiler
  userDnaProfiles({ udid, dna_profile_id }) {
    return apiClient.get(
      `${DATA_API_URL}/users/dna_profiles/${udid}?dna_profile_id=${dna_profile_id}`
    );
  },
  candidatesForProfileType({
    dna_profile_id,
    sort,
    order,
    page,
    page_size,
    min_confidence,
    max_confidence,
    search_term,
    platoon_id,
    section_id,
  }) {
    return apiClient.get(
      `${DATA_API_URL}/profiler/${dna_profile_id}?search_term=${search_term}&page=${page}&page_size=${page_size}&sort=${sort}&order=${order}&min_confidence=${min_confidence}&max_confidence=${max_confidence}&platoon_id=${platoon_id}&section_id=${section_id}`
    );
  },
  getAbnormalAlerts({ dt_from, dt_to }) {
    return apiClient.get(
      `${DATA_API_URL}/dashboard/abnormal_alerts?dt_from=${dt_from}&dt_to=${dt_to}`
    );
  },
  userStressData({ udid, sort, order, dt_from, dt_to }) {
    return apiClient.get(
      `${DATA_API_URL}/users/stress/${udid}?sort=${sort}&order=${order}&dt_from=${dt_from}&dt_to=${dt_to}`
    );
  },
  userPerformanceData({ udid, sort, order, dt_from, dt_to }) {
    return apiClient.get(
      `${DATA_API_URL}/users/performance/details/${udid}?sort=${sort}&order=${order}&dt_from=${dt_from}&dt_to=${dt_to}`
    );
  },
  userStressAndSpoData({ udid, sort, order, dt_from, dt_to }) {
    return apiClient.get(
      `${DATA_API_URL}/users/stress/spo/${udid}?sort=${sort}&order=${order}&dt_from=${dt_from}&dt_to=${dt_to}`
    );
  },
  userWorkoutDetails({udid,workout_record_id}) {
    return apiClient.get(
      `${DATA_API_URL}/users/workout/details/${udid}/${workout_record_id}`
    );
  },
  userSleepDetails({ udid, sort, order, dt_from, dt_to }) {
    return apiClient.get(
      `${DATA_API_URL}/users/sleep/details/${udid}?sort=${sort}&order=${order}&dt_from=${dt_from}&dt_to=${dt_to}`
    );
  },
  userWellnessDetails({ udid, selected_date, section_id}) {
    return apiClient.get(
      `${DATA_API_URL}/users/wellness/details/${udid}?date=${selected_date}&section=${section_id}`
    );
  },
  userPerformanceTrends({
    dt_from,
    dt_to,
  }) {
    return apiClient.get(
      `${DATA_API_URL}/sections/user/trends?dt_from=${dt_from}&dt_to=${dt_to}`
    );
  },
  topPerformingUsers({
    dt_from,
    dt_to,
    days,
    platoon_id,
    search_term,
    page_num,
  }) {
    return apiClient.get(
      `${DATA_API_URL}/top/performance/users?dt_from=${dt_from}&dt_to=${dt_to}&days=${days}&platoon_id=${platoon_id}&search_term=${search_term}&page_num=${page_num}`
    );
  },
};
